// extracted by mini-css-extract-plugin
export default {"additionalLabel":"LeverageInput_additionalLabel__qvTMX","checkmark":"LeverageInput_checkmark__WNcN5","rtl":"LeverageInput_rtl__uy0St"};